/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Cycle } from '@src/app/model/cycle';
import { MailMerge } from '@src/app/model/mailMerge';
import { Schedule } from '@src/app/model/schedule';
import { Txn } from '@src/app/model/txn';
import { Unit } from '@src/app/model/unit';

export class Billing extends AbstractObject {
  constructor(o: Partial<Billing> = {}) {
    super(o);
  }

  items: BillingItem[] = [];
  bills: Txn[] = [];
  statusId: uuid;
  status: AbstractObject;
  cycleId: uuid;
  cycle: Cycle;

  billedTotal: number;
  totalItems: number;

  outstandingTotal: number;
  outstandingItems: number;

  units: Unit[];
  mailMerges: MailMerge[] = [];
}

export class BillingItem extends AbstractObject {
  constructor(o: Partial<Billing> = {}) {
    super(o);
  }

  billingId: uuid;
  scheduleId: uuid;
  scheduleName: string;
  bCodeId: uuid;
  bCodeName: string;
  schedule: Schedule;
  total: number;
  billed: number;

  vatCode?: string;
  vatRate?: number;
  vatAmount?: number

  myTotal: number; //  Calculated
}
